import { apiInstancePublic } from "../../utils";

interface Response {
  token: string;
}

export const aaspAuth = async (idToken: string) => {
  const response = await apiInstancePublic.post<Response>(
    "/auth/sso/aasp",
    {},
    {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    },
  );

  return response.data;
};
